module.exports = __webpack_public_path__ + "media/images/flags/16/United-Nations-496acc63c395a3994a556028b8f93bd5.png";